import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { PasslySelect, PasslyTextField } from '@app/components';
import { IStringFilter, ICriteria, StringFilterTypes } from '@app/models';
import { createStringFilters as filters } from '../../methods';

interface IProps {
    checkValidation: Function;
    criteria: ICriteria;
    patchData: IData;
}

interface IAttribute {
    filter: IStringFilter | null;
    value: string;
}

interface IData {
    value: StringFilterTypes;
    filteredValue?: string;
}

export const LocalizationSelector = (props: IProps) => {
    const { translation } = useTypedTranslation();
    const { checkValidation, criteria, patchData } = props;

    const [localization, setLocalization] = useState<IAttribute>({ filter: null, value: patchData?.filteredValue ?? '' });

    const handleFilterChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value as string;
        changeFilterValue(value);
    };

    const handleInputChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value as string;
        setLocalization(prevState => ({ ...prevState, value: value }));
    };

    const changeFilterValue = (value: string): void => {
        const selectedFilter = filters.find((filter: IStringFilter) => filter.value === value);
        if (selectedFilter !== null && selectedFilter !== undefined) {
            setLocalization(prevState => ({ ...prevState, filter: selectedFilter }));
        }
    };

    useEffect(() => {
        checkValidation(false, null);
        changeFilterValue(patchData?.value);
    }, []);

    useEffect(() => {
        if (localization.filter !== null) {
            const data: IData = {
                value: localization.filter.value
            };

            if (localization.value !== '' && localization.filter.requiresValue) {
                data.filteredValue = localization.value;
                checkValidation(true, data);
            }
            else if (!localization.filter.requiresValue) {
                checkValidation(true, data);
            }
            else {
                checkValidation(false, null);
                return;
            }
        } else {
            checkValidation(false, null);
        }
    }, [localization, criteria]);

    return (
        <div className='attributeSelector'>
            <div className='attributeSelector__row'>
                <PasslySelect
                    id='localizationFilterSelect'
                    label={'AUTH_POLICY_OBJ_PROP_FILTER_LABEL'}
                    value={localization.filter !== null ? localization.filter.value : ''}
                    onChange={handleFilterChange}
                    options={filters}
                />
                <PasslyTextField
                    id='localizationValue'
                    placeholder={translation(criteria.label)}
                    onChange={handleInputChange}
                    value={localization.value}
                    disabled={localization.filter === null || !localization.filter.requiresValue}
                />
            </div>
        </div>
    );
};
